var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"tw:bg-white tw:rounded-xl tw:shadow-sm tw:border tw:border-gray-200 tw:overflow-hidden"},[_c(_setup.SkeletonItem,{attrs:{"height":"tw:h-11","customClass":"tw:w-full tw:rounded-none"}}),_c('div',{class:['tw:space-y-4 tw:p-6 tw:pt-8 ', _vm.customClass]},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }